import React, { useEffect, useState } from "react";
import "./Events.css";

const Events = () => {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const url = process.env.REACT_APP_IMAGE_BASE_URL || process.env.REACT_APP_LINK;

  useEffect(() => {
    const fetchEvents = async () => {
      try {
        const res = await fetch(`${url}/events`);
        const data = await res.json();
        setEvents(Array.isArray(data) ? data : []);
      } catch (err) {
        console.error("Failed to fetch events:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchEvents();
  }, [url]);

  const getImageUrl = (img) => {
    if (!img) return "";
    const str = String(img).replace(/\\/g, "/");
    const base = (url || "").replace(/\/+$/, "");
    return base ? `${base}/${str}` : "";
  };

  const getEventImages = (evt) => {
    let imgs = evt?.images;
    if (!imgs) return [];
    if (typeof imgs === "string") {
      try { imgs = JSON.parse(imgs); } catch { return []; }
    }
    return Array.isArray(imgs) ? imgs : [];
  };

  return (
    <div className="events-page-wrapper">
      <section className="events-hero">
        <div className="events-hero-overlay">
          <h1>Events</h1>
          <p>Stay updated with our latest events and happenings</p>
        </div>
      </section>

      <section className="events-content">
        {loading ? (
          <p className="events-loading">Loading events...</p>
        ) : events.length > 0 ? (
          <div className="events-grid">
            {events.map((evt) => (
              <article key={evt.id} className="event-card">
                <div className="event-card-images">
                  {(() => {
                    const imgs = getEventImages(evt);
                    return imgs.length > 0 ? (
                      <img
                        src={getImageUrl(imgs[0])}
                        alt={evt.title}
                        className="event-card-img"
                      />
                    ) : (
                      <div className="event-card-placeholder">
                        <span>No image</span>
                      </div>
                    );
                  })()}
                </div>
                <div className="event-card-body">
                  <time className="event-date">{evt.date}</time>
                  <h2 className="event-title">{evt.title}</h2>
                  <p className="event-description">
                    {evt.shortDescription || ""}
                  </p>
                </div>
              </article>
            ))}
          </div>
        ) : (
          <p className="events-empty">No events at the moment. Check back soon!</p>
        )}
      </section>
    </div>
  );
};

export default Events;
